import { state } from '@angular/animations';
import {
  EmailFunnelApiResponse,
  GeographicThreatsApiResponse,
  EmailCoverageApiResponse,
  ThreatByTypeApiResponse,
  EventsPendingReviewApiResponse,
  ConfigStatusApiResponse,
  EmailAverageCoverageApiResponse,
  CheckpointProtectionResponse,
  BreakthroughIncidentsAnalysisResponse,
  PendingReviewItemsApiResponse,
} from '../services/es-analytics.service';
import { ConfigurationStatusDetailResponse } from 'src/app/core/models/analytics/es-models';

export const emailCoverageApiResponse: EmailCoverageApiResponse = {
  current_coverage_percentage: 98.5,
  previous_coverage_percentage: 97.8,
  coverage_percentage_change: 0.7,
  last_updated: '2025-08-12T12:00:00Z',
};

export const emailFunnelApiResponse: EmailFunnelApiResponse = {
  total_email_volume: 47293,
  total_email_volume_previous: 46297,
  total_email_volume_pct_change: 2.1,
  total_threats_detected: 4839,
  total_threats_detected_previous: 4321,
  total_threats_detected_pct_change: 12.0,
  total_threats_blocked: 4725,
  total_threats_blocked_previous: 4257,
  total_threats_blocked_pct_change: 11.0,
  total_breakthrough_incidents: 114,
  total_breakthrough_incidents_previous: 106,
  total_breakthrough_incidents_pct_change: 8.0,
};

export const threatsByTypeApiResponse: ThreatByTypeApiResponse = {
  total_security_events: 4725,
  security_events: [
    { value: 'Phishing', count: 1850 },
    { value: 'Malware', count: 920 },
    { value: 'Spam', count: 1580 },
    { value: 'DLP', count: 245 },
    { value: 'Other', count: 130 },
  ],
};

export const geographicThreatsApiResponse: GeographicThreatsApiResponse = {
  geographicThreats: [
    { name: 'United States', count: 1850 },
    { name: 'United Kingdom', count: 920 },
    { name: 'Canada', count: 1580 },
    { name: 'Australia', count: 245 },
    { name: 'Other', count: 130 },
  ],
};

export const eventsPendingReviewApiResponse: EventsPendingReviewApiResponse = {
  total_events_pending_review: 10,
  total_events_pending_review_previous: 5,
  total_events_pending_review_change: 100,
  last_updated: '2025-08-12T12:00:00Z',
};

export const configStatusApiResponse: ConfigStatusApiResponse = {
  config_id: 0,
  config_status: 'Mostly Configured',
  last_updated: '2025-08-12T12:00:00Z',
  // Possiblestatuses: [
  //   { id: 0, name: 'Fully Configured' },
  //   { id: 1, name: 'Mostly Configured' },
  //   { id: 2, name: 'Configuration Required' },
  // ],
};

export const emailAverageCoverageApiResponse: EmailAverageCoverageApiResponse = {
  average_coverage_percentage: 98.5,
  average_coverage_percentage_previous: 97.8,
  average_coverage_percentage_change: 0.7,
};

export const checkpointProtectionResponse: CheckpointProtectionResponse = {
  chartData: [
    { name: 'Inbox', value: 24 },
    { name: 'Junk folder', value: 10 },
  ],
};

export const breakthroughIncidentsAnalysisResponse: BreakthroughIncidentsAnalysisResponse = {
  total_breakthrough_incidents: 114,
  percentage_change: 8.0,
  sender_domain_patterns: [
    { type: 'Temporary email services', count: 42, percentage: 36.8 },
    { type: 'Recently registered domains', count: 38, percentage: 33.3 },
    { type: 'Suspicious domain patterns', count: 34, percentage: 29.8 },
  ],
  subject_line_patterns: [
    { type: 'Urgent verification messages', count: 48, percentage: 42.1 },
    { type: 'Invoice/payment scams', count: 35, percentage: 30.7 },
    { type: 'IT security alerts', count: 31, percentage: 27.2 },
  ],
  attachment_type_patterns: [
    { type: 'PDFs with embedded links', count: 28, percentage: 24.6 },
    { type: 'Documents with macros', count: 21, percentage: 18.4 },
    { type: 'Zip archives', count: 18, percentage: 15.8 },
  ],
  recommended_actions: [
    {
      priority: 'High',
      description: 'Implement stricter domain reputation scoring for recently registered domains',
      estimated_impact: 'Could prevent 38 incidents',
      implementation_effort: 'Medium',
    },
    {
      priority: 'High',
      description: 'Enhanced subject line pattern detection for urgent verification themes',
      estimated_impact: 'Could prevent 48 incidents',
      implementation_effort: 'Low',
    },
    {
      priority: 'Medium',
      description: 'Deploy advanced PDF attachment scanning for embedded links',
      estimated_impact: 'Could prevent 28 incidents',
      implementation_effort: 'High',
    },
    {
      priority: 'Medium',
      description: 'Block temporary email service domains at the gateway level',
      estimated_impact: 'Could prevent 42 incidents',
      implementation_effort: 'Low',
    },
    {
      priority: 'Low',
      description: 'User training program targeting invoice and payment scam recognition',
      estimated_impact: 'Could prevent 35 incidents',
      implementation_effort: 'Medium',
    },
  ],
};

export const pendingReviewItemsApiResponse: PendingReviewItemsApiResponse = {
  items: [
    {
      id: 1,
      eventName: 'Phishing attempt detected in email -No subject-',
      severity: 'High',
      dateTime: '2025-01-18T08:35:00Z',
      threatType: 'Phishing',
      user: 'Maneesh Thammishetti',
      mailbox: 'maneesh.thammishetti@cyflare.com',
      details: 'Suspicious email with no subject containing suspicious links',
      status: 'pending',
      available_actions: ['Alert User of Phishing', 'Dismiss', 'Move to Spam', 'Quarantine', 'Add Notes']
    },
    {
      id: 2,
      eventName: 'Urgent Invoice Payment Required - Action Needed',
      severity: 'High',
      dateTime: '2025-01-18T07:22:00Z',
      threatType: 'Phishing',
      user: 'Joe Morin',
      mailbox: 'joe.morin@cyflare.com',
      details: 'Fraudulent invoice email with embedded payment links',
      status: 'pending',
      available_actions: ['Alert User of Phishing', 'Dismiss', 'Move to Spam', 'Quarantine', 'Add Notes']
    },
    {
      id: 3,
      eventName: 'IT Security Alert: Account Verification Required',
      severity: 'Medium',
      dateTime: '2025-01-18T06:45:00Z',
      threatType: 'Phishing',
      user: 'Chirag Desai',
      mailbox: 'chirag.desai@cyflare.com',
      details: 'Fake IT security alert requesting credential verification',
      status: 'pending',
      available_actions: ['Alert User of Phishing', 'Dismiss', 'Move to Spam', 'Quarantine', 'Add Notes']
    },
    {
      id: 4,
      eventName: 'Your Account Has Been Compromised - Immediate Action Required',
      severity: 'High',
      dateTime: '2025-01-18T05:18:00Z',
      threatType: 'Phishing',
      user: 'Akash Desai',
      mailbox: 'akash.desai@cyflare.com',
      details: 'Account compromise scam with malicious attachment',
      status: 'pending',
      available_actions: ['Alert User of Phishing', 'Dismiss', 'Move to Spam', 'Quarantine', 'Add Notes']
    },
    {
      id: 5,
      eventName: 'Malware detected in PDF attachment',
      severity: 'Critical',
      dateTime: '2025-01-18T04:33:00Z',
      threatType: 'Malware',
      user: 'Dominic Barber',
      mailbox: 'dominic.barber@cyflare.com',
      details: 'PDF attachment contains embedded malicious code',
      status: 'pending',
      available_actions: ['Dismiss', 'Quarantine', 'Add Notes']
    },
    {
      id: 6,
      eventName: 'Bank Security Notice: Unusual Activity Detected',
      severity: 'Medium',
      dateTime: '2025-01-18T03:27:00Z',
      threatType: 'Phishing',
      user: 'Sarah Johnson',
      mailbox: 'sarah.johnson@cyflare.com',
      details: 'Fake banking security notice requesting login credentials',
      status: 'pending',
      available_actions: ['Alert User of Phishing', 'Dismiss', 'Move to Spam', 'Quarantine', 'Add Notes']
    },
    {
      id: 7,
      eventName: 'Suspicious sender from temporary email service',
      severity: 'Medium',
      dateTime: '2025-01-18T02:15:00Z',
      threatType: 'Spam',
      user: 'Michael Brown',
      mailbox: 'michael.brown@cyflare.com',
      details: 'Email from known temporary email service domain',
      status: 'pending',
      available_actions: ['Dismiss', 'Quarantine', 'Add Notes']
    },
    {
      id: 8,
      eventName: 'COVID-19 Relief Fund - Claim Your Benefits Now',
      severity: 'High',
      dateTime: '2025-01-18T01:42:00Z',
      threatType: 'Phishing',
      user: 'Emily Davis',
      mailbox: 'emily.davis@cyflare.com',
      details: 'COVID-19 themed phishing scam with fraudulent benefit claims',
      status: 'pending',
      available_actions: ['Alert User of Phishing', 'Dismiss', 'Move to Spam', 'Quarantine', 'Add Notes']
    },
    {
      id: 9,
      eventName: 'Document macro execution blocked',
      severity: 'High',
      dateTime: '2025-01-18T00:58:00Z',
      threatType: 'Malware',
      user: 'Robert Wilson',
      mailbox: 'robert.wilson@cyflare.com',
      details: 'Word document with malicious macros automatically blocked',
      status: 'pending',
      available_actions: ['Dismiss', 'Quarantine', 'Add Notes']
    },
    {
      id: 10,
      eventName: 'Suspicious ZIP archive detected',
      severity: 'Medium',
      dateTime: '2025-01-17T23:34:00Z',
      threatType: 'Malware',
      user: 'Lisa Anderson',
      mailbox: 'lisa.anderson@cyflare.com',
      details: 'ZIP file contains suspicious executable files',
      status: 'pending',
      available_actions: ['Dismiss', 'Quarantine', 'Add Notes']
    },
    {
      id: 11,
      eventName: 'Promotional newsletter marked as Graymail',
      severity: 'Low',
      dateTime: '2025-01-17T22:15:00Z',
      threatType: 'Graymail',
      user: 'Amanda Thompson',
      mailbox: 'amanda.thompson@cyflare.com',
      details: 'Marketing email from legitimate sender but unwanted by user',
      status: 'pending',
      available_actions: ['Dismiss', 'Quarantine', 'Add Notes']
    },
    {
      id: 12,
      eventName: 'Unusual login attempt detected',
      severity: 'Medium',
      dateTime: '2025-01-17T21:30:00Z',
      threatType: 'Anomaly',
      user: 'David Chen',
      mailbox: 'david.chen@cyflare.com',
      details: 'User account showing unusual access patterns from new location',
      status: 'pending',
      available_actions: ['Dismiss', 'Anomaly Exception', 'Add Notes', 'Reset Password', 'Block User']
    },
    {
      id: 13,
      eventName: 'Unauthorized SaaS application detected',
      severity: 'Medium',
      dateTime: '2025-01-17T20:45:00Z',
      threatType: 'Shadow IT',
      user: 'Michelle Rodriguez',
      mailbox: 'michelle.rodriguez@cyflare.com',
      details: 'User connected to unapproved cloud storage service',
      status: 'pending',
      available_actions: ['Approve This App', 'Dismiss', 'Add Notes']
    },
    {
      id: 14,
      eventName: 'System alert: Database connection anomaly',
      severity: 'High',
      dateTime: '2025-01-17T19:22:00Z',
      threatType: 'Alert',
      user: 'System Administrator',
      mailbox: 'admin@cyflare.com',
      details: 'Automated system alert for unusual database access pattern',
      status: 'pending',
      available_actions: ['Dismiss', 'Add Notes']
    }
  ],
  total_count: 14,
  last_updated: '2025-01-18T08:35:00Z'
};

export const configurationStatusDetailResponse: ConfigurationStatusDetailResponse = {
  organizationId: 1,
  overallStatus: 'Mostly Configured',
  compliancePercentage: 80,
  configurationItems: [
    {
      id: 'mailbox-configured',
      name: 'Mailbox Configured',
      goldStandardSetting: 'Gmail or O365 Configured in SaaS Applications',
      currentStatus: 'compliant',
      canAcceptDeviation: false,
      isPolicySpecific: false,
      isDeviationAccepted: false,
      lastUpdated: '2025-01-18T08:00:00Z'
    },
    {
      id: 'collaboration-tools',
      name: 'Collaboration Tools Configured',
      goldStandardSetting: 'Add additional SaaS applications',
      currentStatus: 'non_compliant',
      canAcceptDeviation: true,
      isPolicySpecific: false,
      isDeviationAccepted: true,
      exceptionNote: 'Organization prefers to use only core applications for security compliance',
      lastUpdated: '2025-01-17T14:30:00Z'
    },
    {
      id: 'policy-configured',
      name: 'Policy configured',
      goldStandardSetting: 'At least one policy configured',
      currentStatus: 'compliant',
      canAcceptDeviation: false,
      isPolicySpecific: false,
      isDeviationAccepted: false,
      lastUpdated: '2025-01-18T09:15:00Z'
    },
    {
      id: 'policy-scope',
      name: 'Policy Scope',
      goldStandardSetting: 'All Users and Groups',
      currentStatus: 'non_compliant',
      canAcceptDeviation: true,
      isPolicySpecific: true,
      isDeviationAccepted: false,
      lastUpdated: '2025-01-18T07:45:00Z'
    },
    {
      id: 'policy-protection-mode',
      name: 'Policy Protection Mode',
      goldStandardSetting: 'Detect and Remediate',
      currentStatus: 'compliant',
      canAcceptDeviation: false,
      isPolicySpecific: true,
      isDeviationAccepted: false,
      lastUpdated: '2025-01-18T08:30:00Z'
    },
    {
      id: 'policy-rule-state',
      name: 'Policy Rule State',
      goldStandardSetting: 'Running',
      currentStatus: 'compliant',
      canAcceptDeviation: true,
      isPolicySpecific: true,
      isDeviationAccepted: false,
      lastUpdated: '2025-01-18T08:30:00Z'
    },
    {
      id: 'phishing-workflow',
      name: 'Phishing workflow',
      goldStandardSetting: 'Quarantine. User is alerted and allowed to request a restore',
      currentStatus: 'compliant',
      canAcceptDeviation: true,
      isPolicySpecific: true,
      isDeviationAccepted: false,
      lastUpdated: '2025-01-18T08:00:00Z'
    },
    {
      id: 'suspected-phishing-workflow',
      name: 'Suspected phishing workflow',
      goldStandardSetting: 'Quarantine. User is alerted and allowed to request a restore',
      currentStatus: 'non_compliant',
      canAcceptDeviation: true,
      isPolicySpecific: true,
      isDeviationAccepted: true,
      exceptionNote: 'Business requirement to allow suspected phishing through with warning for training purposes',
      lastUpdated: '2025-01-17T16:20:00Z'
    },
    {
      id: 'malware-attachments-workflow',
      name: 'Malware attachments workflow',
      goldStandardSetting: 'Quarantine. User is alerted and allowed to request a restore',
      currentStatus: 'compliant',
      canAcceptDeviation: true,
      isPolicySpecific: true,
      isDeviationAccepted: false,
      lastUpdated: '2025-01-18T08:00:00Z'
    },
    {
      id: 'suspected-malware-attachments-workflow',
      name: 'Suspected malware attachments workflow',
      goldStandardSetting: 'Quarantine. User is alerted and allowed to request a restore',
      currentStatus: 'compliant',
      canAcceptDeviation: true,
      isPolicySpecific: true,
      isDeviationAccepted: false,
      lastUpdated: '2025-01-18T08:00:00Z'
    },
    {
      id: 'password-protected-attachments-workflow',
      name: 'Password-protected attachments workflow',
      goldStandardSetting: 'Require the end-user to enter a password',
      currentStatus: 'non_compliant',
      canAcceptDeviation: true,
      isPolicySpecific: true,
      isDeviationAccepted: false,
      lastUpdated: '2025-01-17T11:30:00Z'
    },
    {
      id: 'spam-workflow',
      name: 'Spam workflow',
      goldStandardSetting: 'Email is allowed. Move to Junk folder',
      currentStatus: 'compliant',
      canAcceptDeviation: true,
      isPolicySpecific: true,
      isDeviationAccepted: false,
      lastUpdated: '2025-01-18T08:00:00Z'
    },
    {
      id: 'graymail-workflow',
      name: 'Graymail workflow',
      goldStandardSetting: 'Same as Spam Workflow / Email is allowed. Move to Junk folder',
      currentStatus: 'compliant',
      canAcceptDeviation: true,
      isPolicySpecific: true,
      isDeviationAccepted: false,
      lastUpdated: '2025-01-18T08:00:00Z'
    },
    {
      id: 'severity',
      name: 'Severity',
      goldStandardSetting: 'High',
      currentStatus: 'non_compliant',
      canAcceptDeviation: true,
      isPolicySpecific: true,
      isDeviationAccepted: true,
      exceptionNote: 'Medium severity acceptable for current organization risk tolerance',
      lastUpdated: '2025-01-16T10:00:00Z'
    },
    {
      id: 'security-checkup-report',
      name: 'Security Checkup Report - Default Weekly Report',
      goldStandardSetting: 'Scheduled and Recipients Accurate',
      currentStatus: 'non_compliant',
      canAcceptDeviation: false,
      isPolicySpecific: false,
      isDeviationAccepted: false,
      lastUpdated: '2025-01-15T09:00:00Z'
    }
  ],
  lastUpdated: '2025-01-18T09:15:00Z'
};
